// extracted by mini-css-extract-plugin
module.exports = {"root":"_1YLI0n","input":"_3BMZ4D","checkboxLabel":"_15GaWS","checkbox":"_2QlrKS","brand":"rwUjwF","disabled":"QcSRcL","label":"_1w8T7B"};